import {store} from '../../../store/store.js';
import {ajaxUtil} from '../../../common/AjaxUtil.js';
import {api} from '../../../common/config.js';
import {StorageUtil} from '../../../common/Auth.js';

store.personal = {
    _this: null,
    activeNav: '预约/报名',
    navs: [{
      name: '预约/报名',
      url: '/apply',
      logo: 'icon6'
    }, {
        name: '当前借阅',
        url: '/borrow',
        logo: 'icon1',
        newsNum: 0
    }, {
        name: '历史借阅',
        url: '/history',
        logo: 'icon2'
    }, {
        name: '读书笔记',
        url: '/notelist?idCard=' + store.func.getUserIdCard(),
        logo: 'icon3',

    }, {
        name: '我的收藏',
        url: '/ebookcollect',
        logo: 'icon5',

    }, {
        name: '我的消息',
        url: '/overduemsg',
        logo: 'icon7',
        newsNum: 0
    },{
      name: '设置',
      url: '/setup',
      logo: 'icon8',
    }],
    changeBorrowNum: function (num) {
        this.navs[1].newsNum = num;
    },
};
export default {
    name: 'personal',
    data() {
        store.personal._this = this;
        return {
            imgError: store.imgError_headerIco,
            idCard: store.func.getUserIdCard(),
            readerData: {image: "", idCard: "", phone: ""},
            ...store.personal,
            flag: 0,
        }
    },
    computed: {
        count() {
            return store.wrap.count
        }
    },
    watch: {
        count: function (now, old) {
            this.navs[5].newsNum = now
        }
    },
    beforeMount() {
        this.changeNum();
        this.navs[5].newsNum = store.wrap.count;
        store.wrap.activeRouteName = '';
        if (StorageUtil.getObject("user") == null) {
            return;
        }
        this.readerData = StorageUtil.getObject("user");
        if (store.func.getUserObj() != null && store.func.getUserObj().phone)
            this.flag = 1;
    },
    mounted() {
        if (StorageUtil.getObject("user") == null || store.user == null) {
            this.$router.push('/');
            return;
        }
    },
    methods: {
        changeNum() {
            let url = api.readerBorrower.list.replace('{pageNo}', 1).replace('{pageCount}', 4)
                .replace('{idCard}', this.idCard).replace('{borrowType}', 1);
            ajaxUtil.ajaxJson(url, null, "GET", (data) => {
                this.navs[1].newsNum = data.totalCount;
            },null,this)
        },
        toChange() {
            this.$router.push('/changephone')
        },
        toAddPhone() {
            this.$router.push('/addphone')
        }
    }
}
